__turbopack_context__.v({
  "caption": "Whitepaper-module__3NmXaa__caption",
  "carouselContainer": "Whitepaper-module__3NmXaa__carouselContainer",
  "carouselControls": "Whitepaper-module__3NmXaa__carouselControls",
  "embla": "Whitepaper-module__3NmXaa__embla",
  "embla__container": "Whitepaper-module__3NmXaa__embla__container",
  "embla__next": "Whitepaper-module__3NmXaa__embla__next",
  "embla__prev": "Whitepaper-module__3NmXaa__embla__prev",
  "embla__slide": "Whitepaper-module__3NmXaa__embla__slide",
  "imgContainer": "Whitepaper-module__3NmXaa__imgContainer",
  "text": "Whitepaper-module__3NmXaa__text",
  "title": "Whitepaper-module__3NmXaa__title",
  "whitePaperArticle": "Whitepaper-module__3NmXaa__whitePaperArticle",
  "whitepaperSectionContainer": "Whitepaper-module__3NmXaa__whitepaperSectionContainer",
});
